// TargetLink.js
var TargetLink = pc.createScript('targetLink');

TargetLink.attributes.add('url', { type: 'string' });
TargetLink.attributes.add('sceneId', { type: 'number' });

// initialize code called once per entity
TargetLink.prototype.initialize = function() {
    
};

